import React from "react";
import Navbar from "../components/Navbar";
import Register from "./Register";
import Footer from "../components/Footer";


function RegisterPage() {
    return (
        <>
        <div>
            <Navbar />
            <Register />
        </div>
        <br></br>
        <div >
            <Footer/>
        </div>
        </>
    )
}

export default RegisterPage;